module.exports = __webpack_public_path__ + "img/italy-digestive-diseases-male.6ca91a5e.png";